/** Accounting money formatting — 2 decimals (cents matter), nl-NL EUR. */
export function money(v: number | null | undefined, currency = "EUR"): string {
  if (v == null) return "—";
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
}

/** Render a VAT rate (0.21) as a percentage label ("21%"). */
export function vatPct(rate: number | null | undefined): string {
  if (!rate) return "0%";
  return `${(rate * 100).toFixed(rate * 100 % 1 === 0 ? 0 : 1)}%`;
}
